const Main = () => import('@pages/main/Main')
const Map = () => import('@pages/main/Map')
const CallCenter = () => import('@pages/main/CallCenter')
const Community = () => import('@pages/main/Community')

export const main = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    meta: {}
  },
  {
    path: '/map',
    name: 'Map',
    component: Map,
    meta: {auth: false, title: '离退休人员分布'}
  },
  {
    path: '/call_center',
    name: 'CallCenter',
    component: CallCenter,
    meta: {auth: false, title: '呼叫中心'}
  },
  {
    path: '/community_clinic',
    name: 'Community',
    component: Community,
    meta: {auth: false, title: '社区门诊'}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/main.route.js